aString